import axios from '@/axios'
export default {
  namespaced: true,
  state: {
    greenhouseOptions: JSON.parse(localStorage.getItem('greenhouseOptions') || '[]'), // 大棚
    varietyOptions: JSON.parse(localStorage.getItem('varietyOptions') || '[]'), // 草莓品种
    stageOptions: JSON.parse(localStorage.getItem('stageOptions') || '[]') // 生长时期
  },
  mutations: {
    setGreenhouseOptions(state, data) {
      console.log('大棚数据', data)
      state.greenhouseOptions = data
      localStorage.setItem('greenhouseOptions', JSON.stringify(data))
    },
    setVarietyOptions(state, data) {
      state.varietyOptions = data
      localStorage.setItem('varietyOptions', JSON.stringify(data))
    },
    setStageOptions(state, data) {
      state.stageOptions = data
      localStorage.setItem('stageOptions', JSON.stringify(data))
    }
  },
  actions: {
    async getGreenhouseOptions({ state, commit }) {
      try {
        const response = await axios.post('/api/basic/greenhouse/selection')
        const data = response.data.map(item => ({
          label: item.serialNumber,
          value: item.id
        }))
        commit('setGreenhouseOptions', data)
      } catch (error) {
        throw error
      }
    },
    async getVarietyOptions({ state, commit }) {
      const response = await axios.post('/api/basic/strawberry-variety/selection')
      const data = response.data.map(item => ({
        label: item.varietyName,
        value: item.id
      }))
      commit('setVarietyOptions', data)
    },
    async getStageOptions({ state, commit }) {
      const response = await axios.post('/api/basic/growth-stage/selection')
      const data = response.data.map(item => ({
        label: item.stageName,
        value: item.id
      }))
      commit('setStageOptions', data)
    }
  }
}
